import dynamic from 'next/dynamic';

const SubscriptionsGrid = dynamic(() =>
  import('./SubscriptionsGrid/SubscriptionsGrid')
);
const FeesGrid = dynamic(() => import('./FeesGrid/FeesGrid'));
const AddDriverModal = dynamic(() => import('./AddDriverModal/AddDriverModal'));
const VehicleDetails = dynamic(() => import('./VehicleDetails/VehicleDetails'));
const VehicleControlList = dynamic(() =>
  import('./VehicleControlList/VehicleControlList')
);
const HandoverFinalChecklist = dynamic(() =>
  import('./HandoverFinalChecklist/HandoverFinalChecklist')
);
const DriversGrid = dynamic(() => import('./DriversGrid/DriversGrid'));
const SubscriptionsFilters = dynamic(() =>
  import('./SubscriptionsFilters/SubscriptionsFilters')
);
const DeliveryReturnPlanModal = dynamic(() =>
  import('./DeliveryReturnPlanModal/DeliveryReturnPlanModal')
);

const DeliveryAndReturn = dynamic(() =>
  import('./DeliveryAndReturn/DeliveryAndReturn')
);
const SubscriptionsDocumentsGrid = dynamic(() =>
  import('./SubscriptionDocumentsGrid/SubscriptionDocumentsGrid')
);

const SubscriptionLinkedItems = dynamic(() =>
  import('./SubscriptionLinkedItems/SubscriptionLinkedItems')
);

const AddDocumentModal = dynamic(() =>
  import('./AddDocumentModal/AddDocumentModal')
);
const History = dynamic(() => import('./History/History'));
const Fees = dynamic(() => import('./Fees/Fees'));
const InspectionDeliveryReturnPlanModal = dynamic(() =>
  import(
    './InspectionDeliveryReturnPlanModal/InspectionDeliveryReturnPlanModal'
  )
);
const SubscriptionProductsForm = dynamic(() =>
  import('./SubscriptionProductsForm/SubscriptionProductsForm')
);
const SigningContractDetailsSection = dynamic(() =>
  import('./SigningContractDetailsSection/SigningContractDetailsSection')
);

const ResetHandoverMethodModal = dynamic(() =>
  import('./ResetHandoverMethodModal/ResetHandoverMethodModal')
);

const SubscriptionSendSmsModal = dynamic(() =>
  import('./SubscriptionSendSmsModal/SubscriptionSendSmsModal')
);

const SubscriptionAssignee = dynamic(() =>
  import('./SubscriptionAssignee/SubscriptionAssignee')
);

const SubscriptionsGridAutocompleteCell = dynamic(() =>
  import(
    './SubscriptionsGridAutocompleteCell/SubscriptionsGridAutocompleteCell'
  )
);
const SubscriptionSidebar = dynamic(() =>
  import('./SubscriptionSidebar/SubscriptionSidebar')
);
const SubscriptionTabContent = dynamic(() =>
  import('./SubscriptionTabContent/SubscriptionTabContent')
);

const PaymentBilling = dynamic(() => import('./PaymentBilling/PaymentBilling'));
const EditSubscriptionDeliveryDetailsModal = dynamic(() =>
  import(
    './EditSubscriptionDeliveryDetailsModal/EditSubscriptionDeliveryDetailsModal'
  )
);

export {
  SubscriptionsGrid,
  FeesGrid,
  AddDriverModal,
  VehicleDetails,
  VehicleControlList,
  HandoverFinalChecklist,
  DriversGrid,
  SubscriptionsFilters,
  DeliveryReturnPlanModal,
  DeliveryAndReturn,
  SubscriptionsDocumentsGrid,
  SubscriptionLinkedItems,
  AddDocumentModal,
  History,
  Fees,
  InspectionDeliveryReturnPlanModal,
  SubscriptionProductsForm,
  SigningContractDetailsSection,
  ResetHandoverMethodModal,
  SubscriptionSendSmsModal,
  SubscriptionAssignee,
  SubscriptionsGridAutocompleteCell,
  PaymentBilling,
  SubscriptionSidebar,
  SubscriptionTabContent,
  EditSubscriptionDeliveryDetailsModal,
};
